import React from 'react';

import DeleteIcon from "@usas/ui-web/components/icons/DeleteIcon";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ userGroup, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}><span className="hidden-xs">{userGroup.userGroup?.userGroupName || ''}</span>&nbsp;
      <div className={global.IconButton}>
        <button
          className={global.IconButton}
          type="button"
          onClick={() => { onDeleteClicked(userGroup.userAccountGroupId); }}>
          <DeleteIcon />
        </button>
      </div>
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className="row">
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>User Group</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>{userGroup.userGroup?.userGroupName || <span>&nbsp;</span>}</div>
      </div>
    </div>
  </div>
);

const ManageUserAccountUserGroupSmallGrid = ({ data, isLoading, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              Loading...
            </div>
          </div>
        </div>
      ) : Array.isArray(data) && data.length > 0
        ? data.map((userGroup, i) => (
          <GridRow key={i} userGroup={userGroup} onDeleteClicked={onDeleteClicked} />
        )) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No User Groups</div>
            </div>
          </div>
        )
    }
  </div>
);

export default ManageUserAccountUserGroupSmallGrid;